'use client';

import { Box, Flex, Link, Switch, Typography } from '@coolblue-development/freddy';
import { NodeProps } from '@features/article/types';
import {
  MARTINA_BASE_URL,
  NEGATIVE_KEYWORDS_PATH,
  POSITIVE_KEYWORDS_PATH
} from '@utils/manuelaUtils/constants';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';

export function GoogleAdsInternalTools({ node }: { node: NodeProps }) {
  const googleAdsLinks = getGoogleAdsLinks(node);
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const [GPCChecked, setGPCChecked] = useState(() => !!params.get('google_console'));

  function onSwitch(value: boolean) {
    setGPCChecked(value);

    if (!GPCChecked) {
      params.set('google_console', '1');
    } else {
      params.delete('google_console');
    }

    window.location.href = `?${params.toString()}`;
  }

  return (
    <Box my={300}>
      <Typography variant='h2' mb={300}>
        Google Ads
      </Typography>
      <Flex pb={400} direction='column' gap={100} alignItems='flex-start'>
        {googleAdsLinks.map(({ title, link }, index) => (
          <Link key={index} href={link} target='_blank'>
            {title}
          </Link>
        ))}
        <Switch
          mt={200}
          label='Show Google Publisher Console'
          checked={GPCChecked}
          onChange={onSwitch}
        />
      </Flex>
    </Box>
  );
}

function getGoogleAdsLinks(nodeInfo: NodeProps) {
  const { relativeUrl } = nodeInfo;

  if (!relativeUrl) return [];

  const keywords = {
    title: 'Add keywords to Google Ads',
    link: getKeywordsUrl('positive', relativeUrl)
  };
  const negativeKeywords = {
    title: 'Add negative keywords to Google Ads',
    link: getKeywordsUrl('negative', relativeUrl)
  };

  return [keywords, negativeKeywords];
}

function getKeywordsUrl(type: 'positive' | 'negative', pageUrl: string) {
  const keyWordType = type === 'positive' ? POSITIVE_KEYWORDS_PATH : NEGATIVE_KEYWORDS_PATH;
  const baseUrl = MARTINA_BASE_URL + keyWordType;

  return baseUrl + `?landings-page=${pageUrl}&referrer=webshop`;
}
